import React from "react";

import styled from "styled-components";

import Icon from "components/atoms/Icon";

const Menu = styled.div`
    position: fixed;
    z-index: 90;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px;
    border: 1px solid #d6e0eb;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16);
    backdrop-filter: blur(8px);
`;

const MenuItem = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #23384d;
    cursor: pointer;

    &:hover:not(:disabled) {
        background: #eef4f8;
    }

    &:disabled {
        opacity: 0.42;
        cursor: not-allowed;
    }
`;

const Divider = styled.div`
    width: 1px;
    height: 18px;
    margin: 0 2px;
    background: #dbe4ee;
    border-radius: 999px;
`;

const TooltipWrap = styled.div`
    position: relative;
    display: inline-flex;
`;

const Tooltip = styled.div`
    position: absolute;
    left: 50%;
    bottom: calc(100% + 8px);
    transform: translateX(-50%);
    display: inline-flex;
    padding: 4px 6px;
    width: max-content;
    max-width: 300px;
    background-color: rgba(11, 33, 44, 0.9);
    border-radius: 4px;
    text-align: center;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
    color: var(--color-White);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition:
        opacity 120ms ease,
        visibility 120ms ease;
    z-index: 1;

    ${TooltipWrap}:hover &,
    ${TooltipWrap}:focus-within & {
        opacity: 1;
        visibility: visible;
    }
`;

const NOTE_SELECTION_ACTIONS = [
    {
        id: "copy",
        label: "복사하기",
        icon: "copy",
        iconColor: "#486581",
        group: "clipboard",
    },
    {
        id: "cut",
        label: "잘라내기",
        icon: "copyCut",
        iconColor: "#486581",
        group: "clipboard",
    },
    {
        id: "citation-create",
        label: "인용 추가",
        icon: "quoteAdd",
        iconColor: "#0f8f6f",
        group: "citation",
    },
    {
        id: "review-create",
        label: "리뷰 추가",
        icon: "thread",
        iconColor: "#0f8f6f",
        group: "review",
    },
    {
        id: "ai-edit",
        label: "AI 편집",
        icon: "aiResponse",
        iconColor: "#2563eb",
        group: "ai",
    },
];

function NoteSelectionActionMenu({ actions = {}, menuRef, position }) {
    return (
        <Menu ref={menuRef} style={{ top: position.top, left: position.left }}>
            {NOTE_SELECTION_ACTIONS.map((item, index) => {
                const previousItem = NOTE_SELECTION_ACTIONS[index - 1] || null;
                const showDivider = previousItem && previousItem.group !== item.group;
                const onSelect = actions[item.id];
                return (
                    <React.Fragment key={item.id}>
                        {showDivider ? <Divider /> : null}
                        <TooltipWrap>
                            <MenuItem
                                type="button"
                                aria-label={item.label}
                                disabled={typeof onSelect !== "function"}
                                onClick={onSelect}
                            >
                                <Icon name={item.icon} size="14px" color={item.iconColor} />
                            </MenuItem>
                            <Tooltip>{item.label}</Tooltip>
                        </TooltipWrap>
                    </React.Fragment>
                );
            })}
        </Menu>
    );
}

export default NoteSelectionActionMenu;
